import { Rutas } from '@/constants/rutas';

export const NavigationJugadoresItems = [
    {
        title: 'Lesionados',
        shortTitle: 'Lesiones',
        path: Rutas.JUGADORES_LESIONADOS,
    },
    {
        title: 'Sancionados',
        shortTitle: 'Sanciones',
        path: Rutas.JUGADORES_SANCIONADOS,
    },
    {
        title: 'Dudas',
        shortTitle: 'Dudas',
        path: Rutas.JUGADORES_DUDAS,
    },
    {
        title: 'Apercibidos',
        shortTitle: 'Apercibidos',
        path: Rutas.JUGADORES_APERCIBIDOS,
    },
    {
        title: 'Lanzadores de Penaltis',
        shortTitle: 'Penaltis',
        path: Rutas.LANZADORES_PENALTIS,
    },
];
